import script from './button-group.vue_vue_type_script_lang.mjs';
export { default } from './button-group.vue_vue_type_script_lang.mjs';
import { render } from './button-group.vue_vue_type_template_id_1bab7d77_lang.mjs';

script.render = render;
script.__file = "packages/components/button/src/button-group.vue";
//# sourceMappingURL=button-group2.mjs.map
